export const navbardata = [
    {
        routerLink: 'dashboard',
        icon: 'assets/icon/dashboard.svg',
        label: "Dashboard",
        show:false
    },
    {
        routerLink: 'ai-assistant',
        icon: 'assets/img/chatbot.png',
        label: "AI Assistant",
        show:false
    },
    {
        routerLink: 'master-menu',
        icon: 'assets/icon/folder.svg',
        label: "MasterData",
        show:false
    },
    {
        routerLink: 'employee-management',
        icon: 'assets/icon/employee.svg',
        label: "Employee Management",
        show:false
    },
    {
        routerLink: '/admin/user-detail',
        icon: 'assets/icon/user.svg',
        label: "User Details",
        show:false
    },
    {
        routerLink: 'user-privileges',
        icon: 'assets/icon/user privilage.svg',
        label: "User Privileges",
        show:false
    },
    {
        routerLink: 'Meeting',
        icon: 'assets/icon/employee.svg',
        label: "Meeting",
        show:false
    },
     {
         routerLink: 'products',
         icon: 'assets/icon/products.svg',
         label: "Products"
     },
    // {
    //     routerLink: 'product-advice',
    //     icon: 'assets/icon/product advice.svg',
    //     label: "Production Advice",
    //     show:false
    // },
    // {
    //     routerLink: 'productions',
    //     icon: 'assets/icon/production.svg',
    //     label: "Productions",
    //     show:false
    // },
    {
        routerLink: 'Factory',
        icon: 'assets/icon/production.svg',
        label: "Factory",
        show:false
    },
//     {
//     routerLink: 'Mixing',
//     icon: 'assets/icon/production.svg',
//     label: "Mixing Machine",
//     show:false
// },
{
    routerLink: 'mixing-ii/job-queue-page',
    icon: 'assets/icon/mixing-job.png',
    label: "Mixing job",
    show:false
},
    // {
    //     routerLink: 'brands',
    //     icon: 'assets/icon/brand.svg',
    //     label: "Brands"
    // },
    {
        routerLink: 'department',
        icon: 'assets/icon/department.svg',
        label: "Department",
        show:false
    },
    {
        routerLink: 'Warehouse',
        icon: 'assets/icon/department.svg',
        label: "Warehouse",
        show:false
    },
    {
        routerLink: 'employee-attendence',
        icon: 'assets/icon/employee.svg',
        label: "Employee Attendence",
        show:false
    },
    // ↓↓↓ ADD THIS NEW ITEM RIGHT HERE ↓↓↓
    {
        routerLink: 'employee-attendance-beta',
        icon: 'assets/icon/employee-attendance-be.svg', // You can use the same icon or a different one
        label: "Employee Attendance Beta",
        show:false
    },
    {
        routerLink: 'Web-Punching',
        icon: 'assets/icon/biometric-attendance.png', // You can use the same icon or a different one
        label: "Web Punching",
        show:false
    },
    {
        routerLink: 'folder',
        icon: 'assets/icon/folder.svg',
        label: "Shan's App Folder",
        show:false
    },
    {
        routerLink: 'KYC',
        icon: 'assets/icon/kyc.svg',
        label: "KYC",
        show:false
    },
    {
        routerLink: 'Attendance-request',
        icon: 'assets/icon/attendance.svg',
        label: "Attendance Request",
        show:false
    },
    {
        routerLink: 'Leave-request-view',
        icon: 'assets/icon/leave-request.svg',
        label: "Leave Requests",
        show:false
    },
    {
        routerLink: 'Marketing',
        icon: 'assets/icon/study.svg',
        label: "Marketing",
        show:false
    },
    {
        routerLink: 'marketing-visit',
        icon: 'assets/icon/visit.svg',
        label: "Marketing Visit",
        show:false
    },
    {
        routerLink: 'customer',
        icon: 'assets/icon/customer.svg',
        label: "Customers",
        show:false
    },
    {
    routerLink: 'customer-survey-menu',
    icon: 'assets/icon/customer-survey.png',
    label: "Customer Survey",
    show:false
},
    {
        routerLink: 'CRM',
        icon: 'assets/icon/crm.svg',
        label: "CRM",
        show:false
    },
    {
        routerLink: 'operation',
        icon: 'assets/icon/crm.svg',
        label: "Operations",
        show:false
    },
    {
        routerLink: 'customer-visit',
        icon: 'assets/icon/visit.svg',
        label: "Customer Visit",
        show:false
    },
    {
        routerLink: 'customer-approval',
        icon: 'assets/icon/location.svg',
        label: "Customer Location Updates",
        show:false
    },
    {
        routerLink: 'leads',
        icon: 'assets/icon/crm.svg',
        label: "Leads",
        show:false
    },
    {
        routerLink: 'message-menu',
        icon: 'assets/icon/message.svg',
        label: "Messaging Broadcast",
        show:false
    },
    {
        routerLink: 'invoices',
        icon: 'assets/icon/kyc.svg',
        label: "Sales",
        show:false
    },
    {
        routerLink: 'sales-projection',
        icon: 'assets/icon/saleprojection.svg',
        label: "Sales Projections",
        show:false
    },
    {
        routerLink: 'receipts',
        icon: 'assets/icon/department.svg',
        label: "Receipts",
        show:false
    },
    {
        routerLink: 'reports',
        icon: 'assets/icon/reports.svg',
        label: "Reports",
        show:false
    },
    {
        routerLink: 'kpi-monthly-report',
        icon: 'assets/icon/reports.svg',   // reuse kpi.svg or use reports.svg
        label: "KPI Monthly Report",
        show: false
     },
    // {
    //     routerLink: 'machine',
    //     icon: 'assets/icon/settings.svg',
    //     label: "Machines",
    //     show:false
    // },
    {
        routerLink: 'sale-orders',
        icon: 'assets/icon/products.svg',
        label: "Sale Orders",
        show:false
    },
    {
        routerLink: 'kpi-menu',
        icon: 'assets/icon/kpi.svg',
        label: "KPI",
        show:false
    },
    {
        routerLink: 'product-stock',
        icon: 'assets/icon/stock.svg',
        label: "Product Stock",
        show:false
    },
    {
        routerLink: 'customer-compliant',
        icon: 'assets/icon/complaint.svg',
        label: "Customer Complaints",
        show:false
    },
    {
        routerLink: 'product-complaint',
        icon: 'assets/icon/complaint_doll.svg',
        label: "Product Complaints",
        show:false
    },
    // {
    //     routerLink: 'factory-projection-listing',
    //     icon: 'assets/icon/factory.svg',
    //     label: "factory projection",
    //     show:false
    // },
    {
        routerLink: 'hrm-menu',
        icon: 'assets/icon/factory.svg',
        label: "HR Module",
        show:false
    },

    {
    routerLink: 'hrm-menu/vacation-monitoring',
    icon: 'assets/icon/crm.svg',
    label: "Hr Portal",
    show: false
    },
    // {
    //     routerLink: 'new-hrm-menu',
    //     icon: 'assets/icon/factory.svg',
    //     label: "New HR Module",
    //     show:false
    // },
    {
        routerLink: 'complaint',
        icon: 'assets/icon/complaint_doll.svg',
        label: "Complaints",
        show:false
    },
    {
        routerLink: 'settings-menu',
        icon: 'assets/icon/settings.svg',
        label: "Settings",
        show:false
    },
    // {
    //     routerLink: 'Version',
    //     icon: '',
    //     label: "Version - 1.0.0",
    //     show:false
    // },
    // {
    //     routerLink: 'temp',
    //     icon: '',
    //     label: "",
    //     show:false
    // },
    // {
    //     routerLink: 'temp',
    //     icon: '',
    //     label: "",
    //     show:false
    // },
   
    
]